// extracted by mini-css-extract-plugin
module.exports = {"featureItem":"addons_featureItem__2VbQI","clientDeskWrapper":"addons_clientDeskWrapper__4E3Wf","rightDark":"addons_rightDark__1iALf"};